export default __webpack_public_path__ + "static/media/Respond_Valkyrie.36580edb.svg";